import { lazy } from "react";

// project import
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Dashboard";
import PagesLayout from "layout/Pages";
import SimpleLayout from "layout/Simple";
import { SimpleLayoutType } from "config";
        

//-------------------------------------
// Template pages routing
const AuthLogin = Loadable(lazy(() => import("pages/auth/login")));
const AuthRegister = Loadable(lazy(() => import("pages/auth/register")));
const AuthForgotPassword = Loadable(lazy(() => import("pages/auth/forgot-password")));
const AuthResetPassword = Loadable(lazy(() => import("pages/auth/reset-password")));
const AuthResetPasswordResponse = Loadable(lazy(() => import("pages/auth/reset-password-confirmation")));
const AuthCheckMail = Loadable(lazy(() => import("pages/auth/check-mail")));
const AuthCodeVerification = Loadable(lazy(() => import("pages/auth/code-verification")));

const MaintenanceError = Loadable(lazy(() => import("pages/maintenance/404")));
const MaintenanceError500 = Loadable(lazy(() => import("pages/maintenance/500")));
const MaintenanceUnderConstruction = Loadable(lazy(() => import("pages/maintenance/under-construction")));
const MaintenanceComingSoon = Loadable(lazy(() => import("pages/maintenance/coming-soon")));

//-------------------------------------
// pages routing

const DashboardRouter = Loadable(lazy(() => import("pages/content/dashboards/router")));
const DashboardDireccion = Loadable(lazy(() => import("pages/content/dashboards/direccion")));
const DashboardAdministrador = Loadable(lazy(() => import("pages/content/dashboards/administrador")));

// Kanban
const KanbanPage = Loadable(lazy(() => import("pages/content/kanban")));

// Tasks Board
const TasksBoard = Loadable(lazy(() => import("apps/tasks-kanban-board")));

// Agenda Servicios
const AgendaDiaria = Loadable(lazy(() => import("pages/content/agenda-servicios/agenda-diaria")));
const CalendarioMensual = Loadable(lazy(() => import("pages/content/agenda-servicios/calendario-mensual")));

// Catálogos
const CatalogosUsuarios = Loadable(lazy(() => import("pages/content/catalogos/usuarios")));
const CatalogosClientes = Loadable(lazy(() => import("pages/content/catalogos/clientes")));
const CatalogosClientesRepresentantes = Loadable(lazy(() => import("pages/content/catalogos/clientes/representantes")));
const CatalogosProyectos = Loadable(lazy(() => import("pages/content/catalogos/proyectos")));
const CatalogosContextosIA = Loadable(lazy(() => import("pages/content/catalogos/contextos-ia")));

// Proyectos
const SelectorProyectos = Loadable(lazy(() => import("pages/content/selector-proyectos")));
const NuevoProyecto = Loadable(lazy(() => import("pages/content/selector-proyectos/nuevo-proyecto")));
const ProyectoActivo = Loadable(lazy(() => import("pages/content/selector-proyectos/proyecto-activo")));
const DashboardProyecto = Loadable(lazy(() => import("pages/content/dashboard-proyecto")));
const VisionEstrategica = Loadable(lazy(() => import("pages/content/plan-estrategico/vision-estrategica")));
const ObjetivoSmart = Loadable(lazy(() => import("pages/content/plan-estrategico/objetivo-smart")));
const Cronograma = Loadable(lazy(() => import("pages/content/plan-estrategico/cronograma")));
const PlanificadorSemanal = Loadable(lazy(() => import("pages/content/plan-estrategico/planificador-semanal")));
const AdministradorTareas = Loadable(lazy(() => import("pages/content/plan-estrategico/administrador-tareas")));
const MonitorFinanciero = Loadable(lazy(() => import("pages/content/monitor-financiero")));
const MonitorFinancieroGlobal = Loadable(lazy(() => import("pages/content/monitor-financiero/MonitorFinancieroGlobal")));
const MonitorFinancieroUnidad = Loadable(lazy(() => import("pages/content/monitor-financiero/MonitorFinancieroUnidad")));
const HistorialReportes = Loadable(lazy(() => import("pages/content/reporte-mensual/historial-reportes")));
const GeneradorBorrador = Loadable(lazy(() => import("pages/content/reporte-mensual/generador-borrador")));
const Diagnostico360Digital = Loadable(lazy(() => import("pages/content/inteligencia-diagnostico/diagnostico-360-digital")));
const ChecklistArranque = Loadable(lazy(() => import("pages/content/inteligencia-diagnostico/checklist-arranque")));
const MotorEstrategicoAdaptativo = Loadable(lazy(() => import("pages/content/motor-estrategico-adaptativo")));
const AnalisisDeProcesos = Loadable(lazy(() => import("pages/content/sistematizacion-estructura-organizacional/procesos-de-la-empresa/analisis-de-procesos")));
const PresentacionAnalisisProcesos = Loadable(lazy(() => import("pages/content/sistematizacion-estructura-organizacional/procesos-de-la-empresa/analisis-de-procesos/presentacion/PresentacionAnalisisProcesos")));
const ProcesosDeLaEmpresa = Loadable(lazy(() => import("pages/content/sistematizacion-estructura-organizacional/procesos-de-la-empresa")));
const DetalleProceso = Loadable(lazy(() => import("pages/content/sistematizacion-estructura-organizacional/procesos-de-la-empresa/detalle-proceso-etapa")));
const ProcesoEtapas = Loadable(lazy(() => import("pages/content/sistematizacion-estructura-organizacional/procesos-de-la-empresa/proceso-etapas")));
const PerfilesDePuestos = Loadable(lazy(() => import("pages/content/sistematizacion-estructura-organizacional/organigrama-y-perfiles-de-puestos")));
const AnalisisEstructuraOrg = Loadable(lazy(() => import("pages/content/sistematizacion-estructura-organizacional/analisis-de-estructura-organizacional")));
const PresentacionAnalisisEstructuraOrg = Loadable(lazy(() => import("pages/content/sistematizacion-estructura-organizacional/analisis-de-estructura-organizacional/presentacion/PresentacionOrganigrama")));
const AdministradorArchivos = Loadable(lazy(() => import("pages/content/administrador-archivos")));
const ModuloMinutas = Loadable(lazy(() => import("pages/content/modulo-minutas")));
const ProcesadorMinuta = Loadable(lazy(() => import("pages/content/modulo-minutas/procesador-minuta")));
const DetalleMinuta = Loadable(lazy(() => import("pages/content/modulo-minutas/detalle-minuta")));

// Cliente portal
const ClienteDashboard = Loadable(lazy(() => import("pages/content/cliente/dashboard")));
const ClienteVisualizacionPlan = Loadable(lazy(() => import("pages/content/cliente/plan-estrategico/visualizacion")));
const ClienteTareas = Loadable(lazy(() => import("pages/content/cliente/plan-estrategico/tareas")));
const ClienteReportesMensuales = Loadable(lazy(() => import("pages/content/cliente/reportes-mensuales")));
const ClienteRepositorioDeArchivos = Loadable(lazy(() => import("pages/content/cliente/repositorio-de-archivos")));
const ClienteMonitorFinanciero = Loadable(lazy(() => import("pages/content/cliente/monitor-financiero")));
const ClienteDiagnostico360 = Loadable(lazy(() => import("pages/content/cliente/diagnostico-360")));
const ClienteDescripcionesPuestos = Loadable(lazy(() => import("pages/content/cliente/descripciones-puestos")));
const ClienteDescripcionesProcesos = Loadable(lazy(() => import("pages/content/cliente/descripciones-procesos")));

// Clientes
const ClientesDashboard = Loadable(lazy(() => import("pages/content/clientes/dashboard")));
const ClientesVisionEstrategica = Loadable(lazy(() => import("pages/content/clientes/plan-estrategico/vision-estrategica")));
const ClientesObjetivoSmart = Loadable(lazy(() => import("pages/content/clientes/plan-estrategico/objetivo-smart")));
const ClientesCronograma = Loadable(lazy(() => import("pages/content/clientes/plan-estrategico/cronograma")));
const ClientesPlanificadorSemanal = Loadable(lazy(() => import("pages/content/clientes/plan-estrategico/planificador-semanal")));
const ClientesAdministradorDeTareas = Loadable(lazy(() => import("pages/content/clientes/plan-estrategico/administrador-de-tareas")));
const ClientesReportesMensuales = Loadable(lazy(() => import("pages/content/clientes/reportes-mensuales")));
const RepositorioDeArchivos = Loadable(lazy(() => import("pages/content/repositorio-de-archivos")));
const ClientesMonitorFinanciero = Loadable(lazy(() => import("pages/content/clientes/monitor-financiero")));
const ClientesDiagnostico360 = Loadable(lazy(() => import("pages/content/clientes/requerimientos-de-informacion/diagnostico-360")));
// Sistematizacion y Estructura Organizacional (clientes) - Reuses admin components
const ClientesAnalisisEstructuraOrg = Loadable(lazy(() => import("pages/content/clientes/sistematizacion-estructura-organizacional/analisis-de-estructura-organizacional")));
const ClientesAnalisisDeProcesos = Loadable(lazy(() => import("pages/content/clientes/sistematizacion-estructura-organizacional/analisis-de-procesos")));
// Requerimientos de informacion (clientes) - Reuses admin components
const ClientesOrganigramaPerfilesPuestos = Loadable(lazy(() => import("pages/content/clientes/requerimientos-de-informacion/organigrama-y-perfiles-de-puestos")));
const ClientesProcesosDeLaEmpresa = Loadable(lazy(() => import("pages/content/clientes/requerimientos-de-informacion/procesos-de-la-empresa")));

// Cuenta
const DatosContacto = Loadable(lazy(() => import("pages/content/cuenta/datos-contacto")));
const EstadoCuenta = Loadable(lazy(() => import("pages/content/cuenta/estado-cuenta")));
const Soporte = Loadable(lazy(() => import("pages/content/cuenta/soporte")));

// Sandbox
const Wireframe = Loadable(lazy(() => import("pages/content/sandbox/wireframe")));




// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          path: "home",
          children: [
            {
              path: "",
              element: <DashboardRouter />,
            },
          ],
        },
        {
          path: "kanban",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <KanbanPage />,
            },
          ],
        },
        {
          path: "tasks-board",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <TasksBoard />,
            },
          ],
        },
        {
          path: "dashboard",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <DashboardDireccion />,
            },
            {
              path: "direccion",
              element: <DashboardDireccion />,
            },
            {
              path: "administrador",
              element: <DashboardAdministrador />,
            },
          ],
        },
        {
          path: "agenda-servicios",
          element: <PagesLayout />,
          children: [
            {
              path: "agenda-diaria",
              element: <AgendaDiaria />,
            },
            {
              path: "calendario-mensual",
              element: <CalendarioMensual />,
            },
          ],
        },
        {
          path: "selector-proyectos",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <SelectorProyectos />,
            },
            {
              path: "proyecto-activo",
              element: <ProyectoActivo />,
            },
            {
              path: "nuevo-proyecto",
              element: <NuevoProyecto />,
            },
          ],
        },
        {
          path: "dashboard-proyecto",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <DashboardProyecto />,
            },
          ],
        },
        {
          path: "inteligencia-diagnostico",
          element: <PagesLayout />,
          children: [
            {
              path: "diagnostico-360-digital",
              element: <Diagnostico360Digital />,
            },
            {
              path: "checklist-arranque",
              element: <ChecklistArranque />,
            },
          ],
        },
        {
          path: "motor-estrategico-adaptativo",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <MotorEstrategicoAdaptativo />,
            },
          ],
        },
        {
          path: "plan-estrategico",
          element: <PagesLayout />,
          children: [
            {
              path: "vision-estrategica",
              element: <VisionEstrategica />,
            },
            {
              path: "objetivo-smart",
              element: <ObjetivoSmart />,
            },
            {
              path: "cronograma",
              element: <Cronograma />,
            },
            {
              path: "planificador-semanal",
              element: <PlanificadorSemanal />,
            },
            {
              path: "administrador-tareas",
              element: <AdministradorTareas />,
            },
          ],
        },
        {
          path: "monitor-financiero",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <MonitorFinancieroGlobal />,
            },
            {
              path: "unidad/:id",
              element: <MonitorFinancieroUnidad />,
            },
          ],
        },
        {
          path: "reporte-mensual",
          element: <PagesLayout />,
          children: [
            {
              path: "historial-reportes",
              element: <HistorialReportes />,
            },
            {
              path: "generador-borrador",
              element: <GeneradorBorrador />,
            },
          ],
        },
        {
          path: "sistematizacion-estructura-organizacional",
          element: <PagesLayout />,
          children: [
            {
              path: "organigrama-y-perfiles-de-puestos",
              element: <PerfilesDePuestos />,
            },
            {
              path: "analisis-de-estructura-organizacional",
              children: [
                {
                  path: "",
                  element: <AnalisisEstructuraOrg />,
                },
                {
                  path: "presentacion",
                  element: <PresentacionAnalisisEstructuraOrg />,
                },
              ],
            },
            {
              path: "procesos-de-la-empresa",
              children: [
                {
                  path: "",
                  element: <ProcesosDeLaEmpresa />,
                },
                {
                  path: "detalle-proceso",
                  element: <DetalleProceso />,
                },
                {
                  path: "proceso-etapas",
                  element: <ProcesoEtapas />,
                },
                {
                  path: "analisis-de-procesos",
                  element: <AnalisisDeProcesos />,
                },
                {
                  path: "analisis-de-procesos/presentacion",
                  element: <PresentacionAnalisisProcesos />,
                },
              ],
            },
          ],
        },
        {
          path: "administrador-archivos",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <AdministradorArchivos />,
            },
          ],
        },
        {
          path: "modulo-minutas",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <ModuloMinutas />,
            },
            {
              path: "procesador-minuta",
              element: <ProcesadorMinuta />,
            },
            {
              path: "detalle-minuta",
              element: <DetalleMinuta />,
            },
          ],
        },
        {
          path: "catalogos",
          element: <PagesLayout />,
          children: [
            {
              path: "usuarios",
              element: <CatalogosUsuarios />,
            },
            {
              path: "clientes",
              element: <CatalogosClientes />,
            },
            {
              path: "clientes/representantes",
              element: <CatalogosClientesRepresentantes />,
            },
            {
              path: "proyectos",
              element: <CatalogosProyectos />,
            },
            {
              path: "contextos-ia",
              element: <CatalogosContextosIA />,
            },
          ],
        },
        {
          path: "cliente",
          element: <PagesLayout />,
          children: [
            {
              path: "dashboard",
              element: <ClienteDashboard />,
            },
            {
              path: "plan-estrategico",
              children: [
                {
                  path: "visualizacion",
                  element: <ClienteVisualizacionPlan />,
                },
                {
                  path: "tareas",
                  element: <ClienteTareas />,
                },
              ],
            },
            {
              path: "reportes-mensuales",
              element: <ClienteReportesMensuales />,
            },
            {
              path: "repositorio-de-archivos",
              element: <ClienteRepositorioDeArchivos />,
            },
            {
              path: "monitor-financiero",
              element: <ClienteMonitorFinanciero />,
            },
            {
              path: "diagnostico-360",
              element: <ClienteDiagnostico360 />,
            },
            {
              path: "descripciones-puestos",
              element: <ClienteDescripcionesPuestos />,
            },
            {
              path: "descripciones-procesos",
              element: <ClienteDescripcionesProcesos />,
            },
          ],
        },
        {
          path: "clientes",
          element: <PagesLayout />,
          children: [
            {
              path: "dashboard",
              element: <ClientesDashboard />,
            },
            {
              path: "plan-estrategico",
              children: [
                {
                  path: "vision-estrategica",
                  element: <ClientesVisionEstrategica />,
                },
                {
                  path: "objetivo-smart",
                  element: <ClientesObjetivoSmart />,
                },
                {
                  path: "cronograma",
                  element: <ClientesCronograma />,
                },
                {
                  path: "planificador-semanal",
                  element: <ClientesPlanificadorSemanal />,
                },
                {
                  path: "administrador-de-tareas",
                  element: <ClientesAdministradorDeTareas />,
                },
              ],
            },
            {
              path: "reportes-mensuales",
              element: <ClientesReportesMensuales />,
            },
            {
              path: "repositorio-de-archivos",
              element: <RepositorioDeArchivos />,
            },
            {
              path: "monitor-financiero",
              element: <ClientesMonitorFinanciero />,
            },
            {
              path: "sistematizacion-estructura-organizacional",
              children: [
                {
                  path: "analisis-de-estructura-organizacional",
                  element: <ClientesAnalisisEstructuraOrg />,
                },
                {
                  path: "analisis-de-procesos",
                  element: <ClientesAnalisisDeProcesos />,
                },
              ],
            },
            {
              path: "requerimientos-de-informacion",
              children: [
                {
                  path: "diagnostico-360",
                  element: <ClientesDiagnostico360 />,
                },
                {
                  path: "procesos-de-la-empresa",
                  element: <ClientesProcesosDeLaEmpresa />,
                },
                {
                  path: "organigrama-y-perfiles-de-puestos",
                  element: <ClientesOrganigramaPerfilesPuestos />,
                },
              ],
            },
          ],
        },
        {
          path: "cuenta",
          element: <PagesLayout />,
          children: [
            {
              path: "datos-contacto",
              element: <DatosContacto />,
            },
            {
              path: "estado-cuenta",
              element: <EstadoCuenta />,
            },
            {
              path: "soporte",
              element: <Soporte />,
            },
          ],
        },
        {
          path: "sandbox",
          element: <PagesLayout />,
          children: [
            {
              path: "wireframe",
              element: <Wireframe />,
            },
          ],
        },
        
      ],
    },

    {
      path: "/maintenance",
      element: <PagesLayout />,
      children: [
        {
          path: "404",
          element: <MaintenanceError />,
        },
        {
          path: "500",
          element: <MaintenanceError500 />,
        },
        {
          path: "under-construction",
          element: <MaintenanceUnderConstruction />,
        },
        {
          path: "coming-soon",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "/auth",
      element: <PagesLayout />,
      children: [
        {
          path: "login",
          element: <AuthLogin />,
        },
        {
          path: "register",
          element: <AuthRegister />,
        },
        {
          path: "forgot-password",
          element: <AuthForgotPassword />,
        },
        {
          path: "reset-password",
          element: <AuthResetPassword />,
        },
        {
          path: "reset-password-confirmation",
          element: <AuthResetPasswordResponse />,
        },
        {
          path: "check-mail",
          element: <AuthCheckMail />,
        },
        {
          path: "code-verification",
          element: <AuthCodeVerification />,
        },
      ],
    },
    {
      path: "/",
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: "contact-us",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "*",
      element: <MaintenanceError />,
    },
  ],
};

export default MainRoutes;
